import { createReducer, on } from '@ngrx/store';
import { loadCitiesSuccess } from './cities.actions';
import { IDropDownList } from '@interfaces';

export interface CitiesState {
  cities: IDropDownList[];
}

export const initialState: CitiesState = {
  cities: [],
};

export const citiesReducer = createReducer(
  initialState,
  on(loadCitiesSuccess, (state, { cities }) => ({
    ...state,
    cities,
  })),
);

export function cityReducer(state: CitiesState | undefined, action: any) {
  return citiesReducer(state, action);
}
